import { is_small_screen } from '../utils'

export default {
  props: {
    playerLogo: {
      default: null
    }
  },
  computed: {
    resumePlaybackId () {
      return `video:${this.currentVideo.canonical}`
    },
    logoOptions () {
      const options = {}

      if (this.playerLogo) {
        options.img = this.playerLogo.url
        options.position = this.playerLogo.position
      }

      return options
    },
    downloadOptions () {
      if (this.currentVideo.is_youtube) {
        return {}
      }

      const options = {}

      if (this.currentVideo.switches.downloadable) {
        options.videoUrl = this.currentVideo.mp4_url
      }
      if (this.currentVideo.switches.allow_download_transcript) {
        options.transcriptUrl = this.router('api.video.subtitle.download', { video: this.currentVideo.id, format: 'srt' })
      }

      return options
    },
    autoplay () {
      return false
    },
    videoSetup () {
      let setup = {
        fill: true,
        controls: true,
        poster: this.currentVideo.switches.animated_thumbnail && this.currentVideo.gif_path ? this.currentVideo.gif_path : this.currentVideo.preview_path,
        autoplay: this.autoplay,
        techOrder: ['html5', 'youtube']
      }

      if (is_small_screen()) {
        setup.autoplay = false
      }

      if (this.currentVideo.is_youtube) {
        setup = Object.assign(setup, {
          sources: [{
            type: 'video/youtube',
            src: 'https://www.youtube.com/watch?v=' + this.currentVideo.video
          }],
          youtube: {
            rel: 0,
            autoplay: setup.autoplay ? 1 : 0,
            // we don't know if the YouTube iframe is touched by the user, so we are not able to show our controls after the video plays
            ytControls: is_small_screen() ? 1 : 0
          }
        })
      }

      return setup
    }
  }
}
